import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Props from './OrderFeesSummaryComponent';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from "../../../../shared/Translation";

class OrderFeesSummary extends Component<Props> {
    render() {
        if(this.props.fees.length === 0) {
            return null;
        }

        return(
            <table className="fees-table">
                    <thead>
                        <tr>
                          <th><p role='heading' aria-level='3'><Translation>{'checkout__additional_fees_and_charges'}</Translation></p></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.getFeeRows()}
                </tbody>
            </table>
        )
    }

    getFeeRows = () => {
        return this.props.fees.map((fee, i) => {
            return <tr key={i}>
                <td className="fees-table__charge">{fee.name}</td>
                <td className="fees-table__amount"><FormattedCurrency>{fee.fee_details.amount}</FormattedCurrency></td>
            </tr>
        });
    }
}

OrderFeesSummary.propTypes = {
    fees: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default OrderFeesSummary
